<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <!-- <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn> -->
        <v-row align="center">
          <slot></slot>
          <a v-on="on" v-bind="attrs" class="text-decoration-underline mt-1">
            I have read and agreed to the General Policy
          </a>
        </v-row>
      </template>
      <!-- <template v-slot:activator="{ on, attrs }">

      <v-checkbox v-model="checkbox">
        <template v-slot:label>
          <div>
            <v-tooltip bottom>
                <a v-on="on" v-bind="attrs">
                  I have read and acccepted the Terms and Condition
                </a>
            </v-tooltip>
          </div>
        </template>
      </v-checkbox>
      </template> -->

      <v-card>
        <v-card-title class="grey lighten-2">
          General Policy
        </v-card-title>

        <v-card-text >
          <!-- <v-subheader>Terms and Conditions</v-subheader>
          <p v-html="GetBookingPolicy().bookingConditions"></p>
          <v-subheader>Cancellation Policy</v-subheader> -->
          <p v-html="GetBookingPolicy().cancellationPolicy"></p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="eventAccept"> I Agree </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      checkbox: false,
    };
  },
  methods: {
    eventAccept: function(){
      this.dialog = false;
      this.$emit('acceptTerm', true);
    }
  },
  computed: {
    ...mapGetters(['GetBookingPolicy'])
  }
};
</script>